import * as React from "react";
import useStyles from "./AppTabs.styles";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { DICTIONARY } from "@/utils/constants/translation.constant";
import { useRouter } from "next/router";

type AppButtonProps = {
  tabNames: string[];
  defaultIndex?: number;
  onChange: (index: number) => void;
};

const AppTabs = (props: AppButtonProps, ref: React.ForwardedRef<any>) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const defaultIndex = props.defaultIndex ?? 0;
  const { classes } = useStyles({ params: { locale: locale! } });
  const [tabIndex, setTabIndex] = useState<number>(defaultIndex);

  let handleClickTab = (index: number) => {
    setTabIndex(index);
    props.onChange(index);
  };

  return (
    <div className={classes.tabNamesContainer}>
      {props.tabNames.map((item, index) => {
        return (
          <div
            key={index}
            className={classes.tabNameContainer}
            onClick={() => handleClickTab(index)}
          >
            <span
              className={`${classes.tabName} ${
                tabIndex === index && classes.activeTab
              } ${index === props.tabNames.length - 1 && classes.lastTab}`}
            >
              {t((DICTIONARY as any)[item])}
            </span>
            {tabIndex === index && (
              <div className={classes.underlineActiveTabContainer}>
                <div className={classes.underlineActiveTab}></div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default React.forwardRef(AppTabs);
